import { render, staticRenderFns } from "./HomeSugal.vue?vue&type=template&id=16c3ec10&"
import script from "./HomeSugal.vue?vue&type=script&lang=ts&"
export * from "./HomeSugal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports